import { render, staticRenderFns } from "./TransferWaiterModal.vue?vue&type=template&id=f0a6d28c&scoped=true&"
import script from "./TransferWaiterModal.vue?vue&type=script&lang=js&"
export * from "./TransferWaiterModal.vue?vue&type=script&lang=js&"
import style0 from "./TransferWaiterModal.vue?vue&type=style&index=0&id=f0a6d28c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a6d28c",
  null
  
)

export default component.exports